/**
 * Kit dizayn konstantalari — Figma "Inson uchun mini app" dan o'lchangan qiymatlar.
 *
 * Ranglar bu yerda EMAS — ular `globals.css` / `uiTokens.ts` dagi CSS o'zgaruvchilari
 * orqali keladi (`var(--c-text)`, `var(--primary)` va h.k.), shunda Click/Payme/Zoomrad
 * super-app'lar rangni runtime'da override qila oladi. Bu fayl faqat rang bo'lmagan
 * o'lchamlarni (radius, o'lcham) markazlashtiradi — "no inline magic numbers".
 */

/** Radius shkalasi (px) — Figma §4 */
export const RADIUS = {
  sm: 12, // tugmalar, kichik to'lov qatorlari, soft tile
  md: 16, // tabbar konteyner, bemor foto, list row, sheet yuqori burchaklari
  lg: 20, // kartalar, chip, teglar
  full: 999, // progress, nuqta, badge, avatar
} as const;

/** Bemor kartasidagi foto (Figma §5.4) */
export const CARD_PHOTO = { width: 100, height: 125, radius: RADIUS.md } as const;

/** Komponent balandliklari (Figma §5) */
export const SIZE = {
  button: 37, // kichik tugma
  cta: 56, // to'liq kenglikdagi CTA
  chip: 36, // filter chip
  tag: 25, // status pill
  segment: 36, // segmented tab segment
  input: 52, // matn/summa maydoni
  navBar: 61, // pastki tab bar (HomeIndicator'siz)
} as const;

/** Inset hairline border — kartalar uchun (drop shadow o'rniga, Figma §4) */
export const HAIRLINE = "inset 0 0 0 1px var(--c-line)";
